import { render, staticRenderFns } from "./SeatRing.vue?vue&type=template&id=eb90b064"
import script from "./SeatRing.vue?vue&type=script&lang=js"
export * from "./SeatRing.vue?vue&type=script&lang=js"
import style0 from "./SeatRing.vue?vue&type=style&index=0&id=eb90b064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports